import { render, staticRenderFns } from "./iconDeleteCard.vue?vue&type=template&id=18527bfe&scoped=true"
import script from "./iconDeleteCard.vue?vue&type=script&lang=js"
export * from "./iconDeleteCard.vue?vue&type=script&lang=js"
import style0 from "./iconDeleteCard.vue?vue&type=style&index=0&id=18527bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18527bfe",
  null
  
)

export default component.exports